export default "__VITE_ASSET__CBFk4Qxm__"